<div class="rankings-header-content-section">
  <div class="rankings-header-content d-flex justify-content-between">
    <div class="header-left-content mx-auto mx-xl-0 my-auto">
      <div class="d-flex align-items-center mb-3">
        <img src="/assets/images/shield.svg" alt="AdFraud IOC-DB" class="mr-3" style="height: 55px;">
        <h1 class="title mb-0">AdFraud IOC-DB</h1>
      </div>
      <p class="subtitle">Open-Source Intelligence Feed of Ad Fraud Indicators of Compromise</p>
    </div>

  </div>
</div>

<div class="rankings-content-section">
  <div class="rankings-main-content">
    <div class="side-navigation rankings" #sideNav>
      <div class='side-navigation-scroll-container'>
        <ng-container *ngFor="let map of sideNavItemsMaps">
          <div class="sidenav-group">
            <h5 [ngClass]="{ active: map.active }">
              <div class="logo-cont">
              </div>
              {{map.title}}
            </h5>
            <ul class="nav flex-row flex-lg-wrap flex-xl-column">
              <ng-container *ngFor="let sideNavItem of map.sideNavItems">
                <li class="nav-item active w-auto w-100" *ngIf="!sideNavItem.hidden">
                  <a class="nav-link" [routerLink]="[basePath, sideNavItem?.id]"
                    [ngClass]="{active: currentSideNavItem && currentSideNavItem.id === sideNavItem.id}">
                    <div class="d-flex">
                      <div class="nav-link-icon-cont {{ sideNavItem?.id }}">
                        <ng-container *ngIf="sideNavItem?.icon; else sidenavicon">
                          <div class="icon-svg" [innerHTML]="sideNavItem.icon | safehtml"></div>
                        </ng-container>
                        <ng-template #sidenavicon>
                          <img src="/assets/images/icon-{{sideNavItem.id}}.png" alt="Icon" />
                        </ng-template>
                      </div>
                      <div class="nav-title">{{sideNavItem.title}}</div>
                    </div>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="right-content rankings high-risk {{currentConfig?.key}}">
      <div class="main-content" [ngClass]="{'loading': loading, 'loadingData': loadingData || downloading}">
        <div class="d-flex justify-content-between rankings-heading flex-column flex-md-row">
          <div class='d-flex align-items-center'>
            <div class='rankings-header'>
              <h2 class="title d-none d-lg-block">
                {{currentConfig?.title}}
              </h2>
              <div class="rankings-heading-title">
                {{currentConfig?.subHeading}}
              </div>
            </div>
          </div>
          <div class="top-bar-heading flex-column flex-md-row flex-nowrap align-items-md-center">
            <div class="results-heading d-flex flex-column align-items-baseline align-items-md-end">
              <div class="lastUpdatedMonthLabel"
                [ngStyle]="{'visibility': lastUpdatedMonthLabel ? 'visible' : 'hidden'}">
                <span>Last Updated: </span>
                <span class="date">{{ lastUpdatedMonthLabel | date:'dd MMMM, yyyy' }}</span>
              </div>
              <div class="align-items-end d-none">
                <div class="loader" data-loader="circle-side" *ngIf="desktop$ | async"></div>
              </div>
              <ng-container *ngIf="osOptions">
                <div class="btn-group toggle-filter insight-toggle-filter" role="group" aria-label="Basic example">
                  <button [hidden]="option.hidden" type="button" class="btn btn-secondary"
                    [disabled]="option.disableIfAnonymous && isAnonymous" *ngFor="let option of osOptions"
                    [ngClass]="{ 'active': option.value == selectedOs }" (click)="changeOs(option.value)"
                    [innerHTML]="option.textOnly">
                  </button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <div class='results-table-cont' [ngClass]="{'d-none': loading}">
          <ng-container *ngIf="desktop$ | async">
            <div class='results-table-scroll-cont' [ngClass]="{'d-none': noResult}" *ngIf="gridData?.length > 0">
              <table class='results-table' fixed-table-header [ngClass]="{ sortable: currentConfig?.sortable }"
                *ngIf="currentConfig?.gridHeaders as rankingGridHeaders">
                <thead>
                  <tr>
                    <ng-container *ngFor="let header of rankingGridHeaders; let last = last;">
                      <ng-container
                        *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || (!currentConfig?.notHideDataIfNA && gridData[0][header.key] !== 'N/A'))">
                        <ng-container *ngIf="header?.key !== 'spacer'; else spacer">
                          <th class="{{header?.key}}" (click)="toggleSort(header)">
                            <app-ranking-gridheader-widget-container [header]="header"
                              [widgetComponent]="header?.headerWidgetComponent" [isLast]="last">
                            </app-ranking-gridheader-widget-container>
                          </th>
                        </ng-container>

                        <ng-template #spacer>
                          <th class="spacer" [style.width]="header?.format">&nbsp;</th>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                </thead>
                <tbody [ngClass]="{'limited-row' : !isEnterprise, 'show-results': !showAnonEmailUnlockForm}"
                  [style.--fade-start]="fadeStart">
                  <tr class="table-row-nav"
                    *ngFor="let dataItem of gridData | slice:0:rowLimit | sortBy:sortHeader?.key:sortHeader?.sort; index as rowIdx"
                    (click)="onItemClick(rowIdx, dataItem)" [style.--row-index]="rowIdx + 1">
                    <ng-container *ngFor=" let header of rankingGridHeaders; index as i">
                      <ng-container *ngIf="header?.key !== 'spacer'; else spacer">
                        <ng-container
                          *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || (!currentConfig?.notHideDataIfNA && gridData[0][header.key] !== 'N/A'))">
                          <td class="grid-data-item {{header.key}}"
                            [attr.inert]="(!isEnterprise && rowIdx >= fadeStart) ? '' : null">
                            <ng-container *ngIf="header?.widgetComponent">
                              <app-ranking-widget-container [data]="dataItem" [header]="header"
                                [reportId]="currentConfig?.reportId" [widgetComponent]="header.widgetComponent"
                                [key]="header?.key" [format]="header.format" [selectedGroup]="selectedGroup">
                              </app-ranking-widget-container>
                            </ng-container>
                          </td>
                        </ng-container>
                      </ng-container>
                      <ng-template #spacer>
                        <td>&nbsp;</td>
                      </ng-template>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
          <ng-container *ngIf="!(desktop$ | async)">
            <div class="d-flex flex-column" [ngClass]="{'d-none': noResult}" *ngIf="gridData?.length > 0">
              <ng-container *ngFor="let dataItem of gridData; index as rowIdx">
                <div class="result-item-cont p-3" *ngIf="currentConfig?.gridHeaders as rankingGridHeaders">
                  <ng-container *ngFor="let header of rankingGridHeaders">
                    <ng-container
                      *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || (!currentConfig?.notHideDataIfNA && gridData[0][header.key] !== 'N/A'))">
                      <div class="d-flex justify-content-between result-item" (click)="onItemClick(rowIdx, dataItem)">
                        <span class="name">{{ header.label }}</span>
                        <div class="value {{ header?.key }}">
                          <app-ranking-widget-container [data]="dataItem" [header]="header"
                            [reportId]="currentConfig?.reportId" [widgetComponent]="header.widgetComponent"
                            [key]="header?.key" [format]="header.format" [selectedGroup]="selectedGroup">
                          </app-ranking-widget-container>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <div class="load-more d-none">
            <button [hidden]="!showLoadMore" class="btn btn-primary" (click)="loadMore()">
              <span>load more</span>
            </button>
            <button [hidden]="!showLoadingMore" class="btn btn-primary"> loading more results...</button>
            <span [ngClass]="{'d-table': noResult}" class="d-none mx-auto no-result">No results found.</span>

            <div class="cta-buttons mx-auto" [ngClass]="{'w-75': isFreemium, 'w-25': isEnterprise }"
              *ngIf="!noResult && (showContactSales || showFreemiumForm)">
              <div class="col" *ngIf="!isEnterprise">
                <button type="button" class="btn btn-primary btn-cta" (click)="scheduleDemo('load_more')">Contact
                  Sales
                </button>
              </div>
              <div class="col" *ngIf="!isAnonymous">
                <button type="button" class="btn btn-primary btn-cta" (click)="openBlockPage()">{{
                  currentConfig.ctaButton }}
                </button>
              </div>
            </div>
          </div>

          <app-rankings-cta-form-anonymous *ngIf="isAnonymous && !showAnonEmailUnlockForm"
            [reportConfig]="currentConfig" [selectedGroup]="selectedGroup"></app-rankings-cta-form-anonymous>

          <app-rankings-cta-form-freemium *ngIf="isFreemium" [reportConfig]="currentConfig"
            [selectedGroup]="selectedGroup"></app-rankings-cta-form-freemium>

        </div>
      </div>
    </div>
  </div>
</div>

<app-rankings-anon-form-v2 [formTitle]="'AdFraud IOC-DB'" (formSubmit)="toggleTableBlur()"></app-rankings-anon-form-v2>

<div class="faq-section">
  <div class="faq-content">
    <div class="faq-title-column">
      <h2 class="faq-title">Frequently<br>Asked<br>Questions</h2>
    </div>
    <div class="faq-column faq-column-middle">
      <div class="faq-item" *ngFor="let faq of faqItemsLeft">
        <h3 class="faq-question">{{ faq.question }}</h3>
        <p class="faq-answer">{{ faq.answer }}</p>
      </div>
    </div>
    <div class="faq-column faq-column-right">
      <div class="faq-item" *ngFor="let faq of faqItemsRight">
        <h3 class="faq-question">{{ faq.question }}</h3>
        <p class="faq-answer">{{ faq.answer }}</p>
      </div>
    </div>
  </div>
</div>

<div class="disclaimer-content">
  <p>
    <b>Disclaimer:</b> The AdFraud IOC Database (the "IOC-DB" or "Lists"),
    reflect Pixalate's opinions with respect to factors that Pixalate believes may be useful to the digital media
    industry. Pixalate is disclosing this information within the IOC-DB based on evidence suggesting that spammers and
    other malicious actors may be utilizing certain identifiers - including but not limited to Data Center IP addresses,
    IPv4 and IPv6 addresses, Connected TV (CTV) device identifiers ("IDs"), malformed CTV bundle IDs, domain names,
    website URLs, and other identified digital markers - to conduct harmful online activities within the digital
    advertising ecosystem. As such, the Lists are only intended for internal and operational use in fraud prevention, ad
    verification efforts, and related initiatives to protect organisations from digital advertising fraud, including
    proxy and video impression IVT, bot traffic, and other forms of automated abuse. Pixalate's opinions are just that,
    opinions, which means that they are neither facts nor guarantees. Pixalate is sharing this data not to impugn the
    standing or reputation of any entity, person or app, but, instead, to report findings and trends pertaining to
    programmatic advertising activity in the time period studied. Pixalate on behalf of itself, its suppliers and
    third-party licensors, expressly disclaims all representations, warranties, and conditions, whether express or
    implied, statutory or otherwise, including any implied warranties of merchantability, fitness for a particular
    purpose, satisfactory quality, and non-infringement of third party rights, to the greatest extent permitted by
    applicable laws.
  </p>

  <p>
    <b>Terms of Use for The IOC-DB:</b> The IOC-DB is provided on an as-is, where is, and as available basis, with any
    and all faults and without warranties of any kind, expressed or implied. Any persons or entities accessing the
    IOC-DB acknowledge and agree that the use of such lists, and any associated Pixalate materials, is solely at their
    own risk. The IOC-DB is provided for internal reference and operational use only, for ad fraud researchers and
    experts, security analysts, and trust and safety advisors to aid their organisations in mitigating and preventing
    fraudulent activities. Any person or entity is strictly prohibited from selling, reselling, or otherwise
    commercially exploiting this data. Any modifications of the IOC-DB and data contained therein is also prohibited.
    Republication of the data in its original form is permitted only with prior written consent and must include proper
    attribution to Pixalate as the source.Persons or entities may not republish, sell, or distribute this data without
    prior written consent received from Pixalate. The IOC-DB shall not be utilised for unlawful discrimination,
    harassment, or any other purposes except for ad fraud prevention and cybersecurity.
  </p>

  <p>
    <b>Complaints:</b> If you believe that any information shared within the IOC-DB is no longer associated with
    fraudulent activity, you may submit a request with evidence and sufficient information to <a
      href="mailto:help@pixalate.com">help@pixalate.com</a> with additional information to provide a basis in
    identifying and reclassifying/removing the specific entry. Pixalate does not warrant the accuracy and completeness
    of the content shared within the IOC-DB and reserves the right to review, update, remove, or retain any information
    at its sole discretion, with or without notice.
  </p>

  <p>© 2026 Pixalate, Inc.</p>

</div>